import { NavLink } from "react-router-dom";

type ContactLinkProps = {
  onNavigate?: () => void;
};

export function ContactLink({ onNavigate }: ContactLinkProps) {
  return (
    <NavLink
      aria-label="Contact OpenAppCart"
      className={({ isActive }) =>
        [
          "oac-contact-link",
          isActive ? "oac-contact-link--active" : "",
        ]
          .filter(Boolean)
          .join(" ")
      }
      onClick={onNavigate}
      title="Contact OpenAppCart"
      to="/contact"
    >
      <span aria-hidden="true" className="oac-envelope-icon">
        <span className="oac-envelope-icon__flap" />
      </span>
    </NavLink>
  );
}
